import FormData from 'form-data';
import { from } from 'rxjs';
import PATHS from '../constants/api.constant';
import useAxiosFunction from '../hooks/useAxiosFunction';
import useLocalStorage from '../hooks/useLocalStorage';
import { TValues } from '../pages/AddPatient.page';
import { PValues } from '../pages/EditPatient.page';
import { SignupTValues } from '../pages/Signup.page';
import { IcaseProps } from '../pages/patient/NewNoteCase';
import { NoteValues } from '../pages/patient/SoapDetails';
import { TUser } from '../pages/profile/Profile.page';

const signUpUser = () => {
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call = (data: SignupTValues) => {
		delete data.confirmpassword;
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.SIGNUP,
				body: data,
				headers: {
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { response, error, loading, call };
};

const forgotPassword = () => {
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call = (email: string) => {
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.FORGOT_PASSWORD,
				body: {
					email,
				},
				headers: {
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { response, error, loading, call };
};

const resetPassword = () => {
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call = (password: string, token: string) => {
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.RESET_PASSWORD,
				body: {
					password,
					token,
				},
				headers: {
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { response, error, loading, call };
};

const loginUser = () => {
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call = (email: string, password: string, islogout: string) => {
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.LOGIN,
				body: {
					email,
					password,
					islogout,
				},
				headers: {
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { response, error, loading, call };
};

const DeleteUser = () => {
	const [token] = useLocalStorage('token', null);
	const [response_del, error, loading, axiosFetch] = useAxiosFunction();
	const call = () => {
		return from(
			axiosFetch({
				method: 'DELETE',
				url: PATHS.DELETE_USER ,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { response_del, error, loading, call };
};


const resendVerificationEmail = () => {
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const resendVefEmail = (email: string) => {
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.RESEND_VERIFICATION_EMAIL,
				body: {
					email
				},
				headers: {
					deviceType: 'WEB',
				},
			}),
		);
	};
	const loadingRes = loading;
	return { response, error, loadingRes, resendVefEmail };
};
const LogoutUser = () => {
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const [token] = useLocalStorage('token', null);
	const call = () => {
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.LOGOUT,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { response, error, loading, call };
};

const getUser = () => {
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const [token] = useLocalStorage('token', null);
	const call = (tokenString?: string) => {
		return from(
			axiosFetch({
				method: 'GET',
				url: PATHS.USER,
				headers: {
					Authorization: tokenString ? `Bearer ${tokenString}` : `Bearer ${token}`,
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { response, error, loading, call };
};

const tokenVerfication = () => {
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const [token] = useLocalStorage('token', null);
	const call = () => {
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.TOKEN_VERIFICATION,
				headers: {
					deviceType: 'WEB',
				},
				body: {
					token: token,
				},
			}),
		);
	};
	return { response, error, loading, call };
};

const getPlan = () => {
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const [token] = useLocalStorage('token', null);
	const call = (tokenString?: string) => {
		return from(
			axiosFetch({
				method: 'GET',
				url: PATHS.PLAN_DETAILS,
				headers: {
					Authorization: tokenString ? `Bearer ${tokenString}` : `Bearer ${token}`,
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { response, error, loading, call };
};

const verifyEmail = () => {
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call = (token?: string) => {
		return from(
			axiosFetch({
				method: 'GET',
				url: PATHS.VERIFY_EMAIL,
				params: {
					token,
				},
			}),
		);
	};
	return { response, error, loading, call };
};
const PatientList = () => {
	const [token] = useLocalStorage('token', null);
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call = (current?: any, serchText?: any) => {
		return axiosFetch({
			method: 'GET',
			url: PATHS.PATIENT_LIST,
			headers: {
				Authorization: `Bearer ${token}`,
				deviceType: 'WEB',
			},
			params: {
				searchText: serchText,
				pageNumber: current,
				limit: 1000,
			},
		});
	};
	return { response, error, loading, call };
};

const editProfile = () => {
	const [token] = useLocalStorage('token', null);
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call_edit = (user: TUser) => {
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.EDIT_PROFILE,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
				body: {
					...user,
					firstName: user.firstname,
					lastName: user.lastname,
				},
			}),
		);
	};
	return { response, error, loading, call_edit };
};

const changePassword = () => {
	const [token] = useLocalStorage('token', null);
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call = (oldPassword: string, newPassword: string) => {
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.CHANGE_PASSWORD,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
				body: {
					oldPassword,
					newPassword,
				},
			}),
		);
	};
	return { response, error, loading, call };
};

const subscriptionList = () => {
	const [token] = useLocalStorage('token', null);
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call = () => {
		return from(
			axiosFetch({
				method: 'GET',
				url: PATHS.SUBSCRIPTION_LIST,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { response, error, loading, call };
};
const generatePaymentLink = () => {
	const [token] = useLocalStorage('token', null);
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call = (priceId: string) => {
		return from(
			axiosFetch({
				method: 'GET',
				url: PATHS.GENERATE_PAYMENT_LINK,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
				params: {
					priceId,
				},
			}),
		);
	};
	return { response, error, loading, call };
};

const freeTrial = () => {
	const [token] = useLocalStorage('token', null);
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const freeTrialCall = (priceId: string) => {
		return from(
			axiosFetch({
				method: 'GET',
				url: PATHS.FREE_TRIAL,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
				params: {
					priceId,
				},
			}),
		);
	};
	return { response, error, loading, freeTrialCall };
};

const addPatient = () => {
	const [token] = useLocalStorage('token', null);
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call = (data: TValues) => {
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.ADD_PATIENT,
				body: data,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { response, error, loading, call };
};

const PatientFetch = () => {
	const [token] = useLocalStorage('token', null);
	const [Patient_response, error, Patient_loading, axiosFetch] = useAxiosFunction();

	const Patient_call = (patientId: string): Promise<void> => {
		return axiosFetch({
			method: 'GET',
			url: PATHS.PATIENT_FETCH + patientId,
			headers: {
				Authorization: `Bearer ${token}`,
				deviceType: 'WEB',
			},
		});
	};

	return { Patient_response, error, Patient_loading, Patient_call };
};

const editPatient = () => {
	const [token] = useLocalStorage('token', null);
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const patient_edit = (data: PValues) => {
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.EDIT_PATIENT,
				body: data,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { response, error, loading, patient_edit };
};
const CaseAdd = () => {
	const [token] = useLocalStorage('token', null);
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call = (data: FormData) => {
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.CASE_ADD,
				body: data,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
					'Content-Type': 'multipart/form-data',
				},
			}),
		);
	};
	return { response, error, loading, call };
};

const CaseUpdate = () => {
	const [token] = useLocalStorage('token', null);
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const Case_Update = (data: IcaseProps) => {
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.CASE_UPDATE,
				body: data,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { response, error, loading, Case_Update };
};
const CaseList = () => {
	const [token] = useLocalStorage('token', null);
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call = (patientId: string) => {
		return from(
			axiosFetch({
				method: 'GET',
				url: PATHS.CASE_LIST,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
				params: {
					// patientId:"89dffbc8-ab70-4a1b-8cf7-224f359665bc",
					patientId: patientId,
				},
			}),
		);
	};
	return { response, error, loading, call };
};
const SoapList = () => {
	const [token] = useLocalStorage('token', null);
	const [SoapResponse, error, loading, axiosFetch] = useAxiosFunction();
	const Soapcall = (caseID: string) => {
		return from(
			axiosFetch({
				method: 'GET',
				url: PATHS.NOTE_LIST,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
				params: {
					// patientId:"89dffbc8-ab70-4a1b-8cf7-224f359665bc",
					caseId: caseID,
				},
			}),
		);
	};
	return { SoapResponse, error, loading, Soapcall };
};

const UserFormList = () => {
	const [token] = useLocalStorage('token', null);
	const [UserFormResponse, error, loading, axiosFetch] = useAxiosFunction();
	const UserFormLists = () => {
		return from(
			axiosFetch({
				method: 'GET',
				url: PATHS.USER_FORM_LIST,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { UserFormResponse, error, loading, UserFormLists };
};
const DeletePatient = () => {
	const [token] = useLocalStorage('token', null);
	const [response_del, error, loading, axiosFetch] = useAxiosFunction();
	const call_del = (patientId: string) => {
		return from(
			axiosFetch({
				method: 'DELETE',
				url: PATHS.DELETE_PATIENT + patientId,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { response_del, error, loading, call_del };
};
const InProgress = () => {
	const [token] = useLocalStorage('token', null);
	const [response_Inprogress, error, loading, axiosFetch] = useAxiosFunction();
	const call_InProgress = () => {
		return from(
			axiosFetch({
				method: 'GET',
				url: PATHS.IN_PROGRESS,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { response_Inprogress, error, loading, call_InProgress };
};
const GetSoapBYId = () => {
	const [token] = useLocalStorage('token', null);
	const [SoapDetailResponse, error, loading, axiosFetch] = useAxiosFunction();
	const call_SoapDetailResponse = (noteid: string) => {
		return from(
			axiosFetch({
				method: 'GET',
				url: PATHS.NOTE_DETAIL,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
				params: {
					noteId: noteid,
				},
			}),
		);
	};
	return { SoapDetailResponse, error, loading, call_SoapDetailResponse };
};

const getCalendarDetails = () => {
	const [token] = useLocalStorage('token', null);
	const [calendarRespone, error, loading, axiosFetch] = useAxiosFunction();
	const calendarCall = (year: string, month: string) => {
		return from(
			axiosFetch({
				method: 'GET',
				url: PATHS.CALENDAR_DETAIL,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
				params: {
					year: year,
					month: month,
				},
			}),
		);
	};
	return { calendarCall, error, loading, calendarRespone };
};

const getCalendarDetailsByday = () => {
	const [token] = useLocalStorage('token', null);
	const [calendarResponeDay, error, loading, axiosFetch] = useAxiosFunction();
	const calendarCallDay = (year: string, month: string, day: string) => {
		return from(
			axiosFetch({
				method: 'GET',
				url: PATHS.CALENDAR_DETAIL_DAY,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
				params: {
					year: year,
					month: month,
					day: day,
				},
			}),
		);
	};
	return { calendarCallDay, error, loading, calendarResponeDay };
};

const DeleteSoap = () => {
	const [token] = useLocalStorage('token', null);
	const [SoapDel, error, loading, axiosFetch] = useAxiosFunction();
	const soap_del = (SoapID: string) => {
		return from(
			axiosFetch({
				method: 'DELETE',
				url: PATHS.SOAP_DELETE + SoapID,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { SoapDel, error, loading, soap_del };
};

const UploadAudio = (formData: FormData) => {
	const [token] = useLocalStorage('token', null);
	const [AudioRes, error, loading, axiosFetch] = useAxiosFunction();
	const Audio_Upload = (formData: FormData) => {
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.IN_PROGRESS,
				body: formData,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
					'Content-Type': 'multipart/form-data',
				},
			}),
		);
	};
	return { AudioRes, error, loading, Audio_Upload };
};
const DownloadNote = () => {
	const [token] = useLocalStorage('token', null);
	const [DownloadResponse, error, loading, axiosFetch] = useAxiosFunction();
	const DownloadCall = (noteid: string) => {
		return from(
			axiosFetch({
				method: 'GET',
				url: PATHS.NOTE_DOWNLOAD,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
				opt: {
					responseType: 'blob',
				},
				params: {
					noteId: noteid,
				},
			}),
		);
	};
	return { DownloadResponse, error, loading, DownloadCall };
};

const editNoteDetails = () => {
	const [token] = useLocalStorage('token', null);
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const noteDetails_edit = (data: NoteValues) => {
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.NOTEDETAILS_UPDATE,
				body: data,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { response, error, loading, noteDetails_edit };
};

const FormId = () => {
	const [token] = useLocalStorage('token', null);
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call = () => {
		return from(
			axiosFetch({
				method: 'GET',
				url: PATHS.FORM_ID,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { response, error, loading, call };
};

const FormIdNotes = () => {
	const [token] = useLocalStorage('token', null);
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call = (data: any) => {
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.FROM_VIEW_LIST,
				body: data,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { response, error, loading, call };
};

const FormCreate = () => {
	const [token] = useLocalStorage('token', null);
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call = (data: any) => {
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.FROM_CREATE_FORM,
				body: data,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
				// Allow long-running form creation (5 minutes)
				timeout: 5 * 60 * 1000,
			}),
		);
	};
	return { response, error, loading, call };
};

const FormModelOption = () => {
	const [token] = useLocalStorage('token', null);
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call = (data: any) => {
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.FORM_CREATE_VIEW,
				body: data,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
				// Listing might trigger heavy aggregation - extend timeout
				timeout: 5 * 60 * 1000,
			}),
		);
	};
	return { response, error, loading, call };
};

const viewModelPdf = () => {
	const [token] = useLocalStorage('token', null);
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call = (data: any) => {
		return from(
			axiosFetch({
				method: 'POST',
				url: PATHS.FORM_VIEW_PDF,
				body: data,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
				// PDF generation can be slow - extend timeout
				timeout: 5 * 60 * 1000,
			}),
		);
	};
	return { response, error, loading, call };
};

const CancelSubscription = () => {
	const [token] = useLocalStorage('token', null);
	const [response, error, loading, axiosFetch] = useAxiosFunction();
	const call = () => {
		return from(
			axiosFetch({
				method: 'GET',
				url: PATHS.SUBSCRIPTION_PLAN_CANCEL,
				headers: {
					Authorization: `Bearer ${token}`,
					deviceType: 'WEB',
				},
			}),
		);
	};
	return { response, error, loading, call };
};

export {
	addPatient,
	CancelSubscription,
	CaseAdd,
	CaseList,
	CaseUpdate,
	changePassword,
	DeletePatient,
	DeleteUser,
	DeleteSoap,
	DownloadNote,
	editNoteDetails,
	editPatient,
	editProfile,
	forgotPassword,
	FormCreate,
	FormId,
	FormIdNotes,
	FormModelOption,
	freeTrial,
	generatePaymentLink,
	getCalendarDetails,
	getCalendarDetailsByday,
	getPlan,
	GetSoapBYId,
	getUser,
	InProgress,
	loginUser,
	resendVerificationEmail,
	LogoutUser,
	PatientFetch,
	PatientList,
	resetPassword,
	signUpUser,
	SoapList,
	subscriptionList,
	tokenVerfication,
	UploadAudio,
	verifyEmail,
	viewModelPdf,
	UserFormList,
};
